module.exports = __webpack_public_path__ + "img/20170814_103336-min.79b92542.jpg";